var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"priority"}},[_c('div',{staticClass:"app-content-list-item"},[_c('h2',[_vm._v(_vm._s(_vm.name))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }